import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { Provider } from 'react-redux';
// import './index.css'
import { store } from './store';
import './assets/scss/style.scss';
import MuiXLicense from './services/MuiXLicense.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <MuiXLicense />
    <App />
  </Provider>,
);
